import { useGetIdentity } from '@refinedev/core';
import { Flex, Spin, Typography } from 'antd';
import { useAntdTheme } from 'antd-style';
import { WarehouseFacilitySelector } from '@admin-panel/components/lib/header';
import type { IERPUser } from '@admin-panel/types';

/**
 * Shown while no working facility is set. Hub picks the first assigned facility on its own, so this is mostly the
 * moment the login loads, or an account with no facility assigned.
 */
const ChooseFacility = () => {
  const token = useAntdTheme();
  const { data: user, isLoading } = useGetIdentity<IERPUser>();
  const assigned = user?.adminUserAttributes?.warehouseIds?.length ?? 0;

  if (isLoading || !user) {
    return (
      <Flex justify="center" style={{ padding: 48 }}>
        <Spin />
      </Flex>
    );
  }

  return (
    <Flex
      vertical
      align="center"
      gap={12}
      style={{ padding: '48px 16px', textAlign: 'center', background: token.colorBgContainer }}
    >
      <Typography.Title level={4} style={{ margin: 0 }}>
        {assigned ? 'Choose your working facility' : 'No facility assigned yet'}
      </Typography.Title>
      <Typography.Text type="secondary">
        {assigned
          ? 'Pick the store or warehouse you are working at. You can switch it any time from the top bar.'
          : 'Ask a Hub admin to add your store or warehouse to your account, then sign in again.'}
      </Typography.Text>
      {assigned > 0 && (
        <div style={{ width: '100%', maxWidth: 400 }}>
          <WarehouseFacilitySelector user={user} />
        </div>
      )}
    </Flex>
  );
};

export default ChooseFacility;
